/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createContractOverviewFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type ContractOverview, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /contracts/{contract-id}/overviews
 */
export interface OverviewsRequestBuilder extends BaseRequestBuilder<OverviewsRequestBuilder> {
    /**
     * GetContractOverviews
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ContractOverview[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ContractOverview[] | undefined>;
    /**
     * GetContractOverviews
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const OverviewsRequestBuilderUriTemplate = "{+baseurl}/contracts/{contract%2Did}/overviews";
/**
 * Metadata for all the requests in the request builder.
 */
export const OverviewsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: OverviewsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createContractOverviewFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
